module.exports = __webpack_public_path__ + "img/logo.8661571b.svg";